export type IconsId =
  | 'youtube'
  | 'x'
  | 'wishlist'
  | 'wishlist-thin'
  | 'wishlist-fill'
  | 'up'
  | 'unmute'
  | 'twitter'
  | 'trash'
  | 'tiktok'
  | 'tick'
  | 'thick'
  | 'stores'
  | 'star'
  | 'star-half'
  | 'star-empty'
  | 'size-guide'
  | 'simple-search'
  | 'shop'
  | 'share'
  | 'secure-lock'
  | 'search'
  | 'right'
  | 'quote'
  | 'question'
  | 'plus'
  | 'plus-thin'
  | 'play'
  | 'pinterest'
  | 'phone'
  | 'percent'
  | 'pause'
  | 'ok'
  | 'no-shows'
  | 'mute'
  | 'minus'
  | 'menu'
  | 'manifest'
  | 'login'
  | 'locator'
  | 'location'
  | 'location-fill'
  | 'location-arrow'
  | 'left'
  | 'instagram'
  | 'informations'
  | 'information'
  | 'info'
  | 'heart-right-fill'
  | 'heart-left-fill'
  | 'gift'
  | 'filter'
  | 'facebook'
  | 'empty-search'
  | 'email'
  | 'down'
  | 'delivery'
  | 'cookies'
  | 'contact'
  | 'coin'
  | 'close'
  | 'close-thin'
  | 'close-circle'
  | 'click-and-collect'
  | 'chevron-up'
  | 'chevron-up-24'
  | 'chevron-right'
  | 'chevron-right-24'
  | 'chevron-left'
  | 'chevron-left-24'
  | 'chevron-down'
  | 'chevron-down-smal'
  | 'chevron-down-24'
  | 'chat'
  | 'cards'
  | 'card'
  | 'cancel'
  | 'booking-in'
  | 'basket'
  | 'arrow-up'
  | 'arrow-left'
  | 'arrow-forward'
  | 'add-account'
  | 'account'
  | 'account-header'
  | '5-columns'
  | '3-columns'
  | '2-columns'
  | '1-columns';

export type IconsKey =
  | 'Youtube'
  | 'X'
  | 'Wishlist'
  | 'WishlistThin'
  | 'WishlistFill'
  | 'Up'
  | 'Unmute'
  | 'Twitter'
  | 'Trash'
  | 'Tiktok'
  | 'Tick'
  | 'Thick'
  | 'Stores'
  | 'Star'
  | 'StarHalf'
  | 'StarEmpty'
  | 'SizeGuide'
  | 'SimpleSearch'
  | 'Shop'
  | 'Share'
  | 'SecureLock'
  | 'Search'
  | 'Right'
  | 'Quote'
  | 'Question'
  | 'Plus'
  | 'PlusThin'
  | 'Play'
  | 'Pinterest'
  | 'Phone'
  | 'Percent'
  | 'Pause'
  | 'Ok'
  | 'NoShows'
  | 'Mute'
  | 'Minus'
  | 'Menu'
  | 'Manifest'
  | 'Login'
  | 'Locator'
  | 'Location'
  | 'LocationFill'
  | 'LocationArrow'
  | 'Left'
  | 'Instagram'
  | 'Informations'
  | 'Information'
  | 'Info'
  | 'HeartRightFill'
  | 'HeartLeftFill'
  | 'Gift'
  | 'Filter'
  | 'Facebook'
  | 'EmptySearch'
  | 'Email'
  | 'Down'
  | 'Delivery'
  | 'Cookies'
  | 'Contact'
  | 'Coin'
  | 'Close'
  | 'CloseThin'
  | 'CloseCircle'
  | 'ClickAndCollect'
  | 'ChevronUp'
  | 'ChevronUp24'
  | 'ChevronRight'
  | 'ChevronRight24'
  | 'ChevronLeft'
  | 'ChevronLeft24'
  | 'ChevronDown'
  | 'ChevronDownSmal'
  | 'ChevronDown24'
  | 'Chat'
  | 'Cards'
  | 'Card'
  | 'Cancel'
  | 'BookingIn'
  | 'Basket'
  | 'ArrowUp'
  | 'ArrowLeft'
  | 'ArrowForward'
  | 'AddAccount'
  | 'Account'
  | 'AccountHeader'
  | 'i5Columns'
  | 'i3Columns'
  | 'i2Columns'
  | 'i1Columns';

export enum Icons {
  Youtube = 'youtube',
  X = 'x',
  Wishlist = 'wishlist',
  WishlistThin = 'wishlist-thin',
  WishlistFill = 'wishlist-fill',
  Up = 'up',
  Unmute = 'unmute',
  Twitter = 'twitter',
  Trash = 'trash',
  Tiktok = 'tiktok',
  Tick = 'tick',
  Thick = 'thick',
  Stores = 'stores',
  Star = 'star',
  StarHalf = 'star-half',
  StarEmpty = 'star-empty',
  SizeGuide = 'size-guide',
  SimpleSearch = 'simple-search',
  Shop = 'shop',
  Share = 'share',
  SecureLock = 'secure-lock',
  Search = 'search',
  Right = 'right',
  Quote = 'quote',
  Question = 'question',
  Plus = 'plus',
  PlusThin = 'plus-thin',
  Play = 'play',
  Pinterest = 'pinterest',
  Phone = 'phone',
  Percent = 'percent',
  Pause = 'pause',
  Ok = 'ok',
  NoShows = 'no-shows',
  Mute = 'mute',
  Minus = 'minus',
  Menu = 'menu',
  Manifest = 'manifest',
  Login = 'login',
  Locator = 'locator',
  Location = 'location',
  LocationFill = 'location-fill',
  LocationArrow = 'location-arrow',
  Left = 'left',
  Instagram = 'instagram',
  Informations = 'informations',
  Information = 'information',
  Info = 'info',
  HeartRightFill = 'heart-right-fill',
  HeartLeftFill = 'heart-left-fill',
  Gift = 'gift',
  Filter = 'filter',
  Facebook = 'facebook',
  EmptySearch = 'empty-search',
  Email = 'email',
  Down = 'down',
  Delivery = 'delivery',
  Cookies = 'cookies',
  Contact = 'contact',
  Coin = 'coin',
  Close = 'close',
  CloseThin = 'close-thin',
  CloseCircle = 'close-circle',
  ClickAndCollect = 'click-and-collect',
  ChevronUp = 'chevron-up',
  ChevronUp24 = 'chevron-up-24',
  ChevronRight = 'chevron-right',
  ChevronRight24 = 'chevron-right-24',
  ChevronLeft = 'chevron-left',
  ChevronLeft24 = 'chevron-left-24',
  ChevronDown = 'chevron-down',
  ChevronDownSmal = 'chevron-down-smal',
  ChevronDown24 = 'chevron-down-24',
  Chat = 'chat',
  Cards = 'cards',
  Card = 'card',
  Cancel = 'cancel',
  BookingIn = 'booking-in',
  Basket = 'basket',
  ArrowUp = 'arrow-up',
  ArrowLeft = 'arrow-left',
  ArrowForward = 'arrow-forward',
  AddAccount = 'add-account',
  Account = 'account',
  AccountHeader = 'account-header',
  i5Columns = '5-columns',
  i3Columns = '3-columns',
  i2Columns = '2-columns',
  i1Columns = '1-columns',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Youtube]: '61697',
  [Icons.X]: '61698',
  [Icons.Wishlist]: '61699',
  [Icons.WishlistThin]: '61700',
  [Icons.WishlistFill]: '61701',
  [Icons.Up]: '61702',
  [Icons.Unmute]: '61703',
  [Icons.Twitter]: '61704',
  [Icons.Trash]: '61705',
  [Icons.Tiktok]: '61706',
  [Icons.Tick]: '61707',
  [Icons.Thick]: '61708',
  [Icons.Stores]: '61709',
  [Icons.Star]: '61710',
  [Icons.StarHalf]: '61711',
  [Icons.StarEmpty]: '61712',
  [Icons.SizeGuide]: '61713',
  [Icons.SimpleSearch]: '61714',
  [Icons.Shop]: '61715',
  [Icons.Share]: '61716',
  [Icons.SecureLock]: '61717',
  [Icons.Search]: '61718',
  [Icons.Right]: '61719',
  [Icons.Quote]: '61720',
  [Icons.Question]: '61721',
  [Icons.Plus]: '61722',
  [Icons.PlusThin]: '61723',
  [Icons.Play]: '61724',
  [Icons.Pinterest]: '61725',
  [Icons.Phone]: '61726',
  [Icons.Percent]: '61727',
  [Icons.Pause]: '61728',
  [Icons.Ok]: '61729',
  [Icons.NoShows]: '61730',
  [Icons.Mute]: '61731',
  [Icons.Minus]: '61732',
  [Icons.Menu]: '61733',
  [Icons.Manifest]: '61734',
  [Icons.Login]: '61735',
  [Icons.Locator]: '61736',
  [Icons.Location]: '61737',
  [Icons.LocationFill]: '61738',
  [Icons.LocationArrow]: '61739',
  [Icons.Left]: '61740',
  [Icons.Instagram]: '61741',
  [Icons.Informations]: '61742',
  [Icons.Information]: '61743',
  [Icons.Info]: '61744',
  [Icons.HeartRightFill]: '61745',
  [Icons.HeartLeftFill]: '61746',
  [Icons.Gift]: '61747',
  [Icons.Filter]: '61748',
  [Icons.Facebook]: '61749',
  [Icons.EmptySearch]: '61750',
  [Icons.Email]: '61751',
  [Icons.Down]: '61752',
  [Icons.Delivery]: '61753',
  [Icons.Cookies]: '61754',
  [Icons.Contact]: '61755',
  [Icons.Coin]: '61756',
  [Icons.Close]: '61757',
  [Icons.CloseThin]: '61758',
  [Icons.CloseCircle]: '61759',
  [Icons.ClickAndCollect]: '61760',
  [Icons.ChevronUp]: '61761',
  [Icons.ChevronUp24]: '61762',
  [Icons.ChevronRight]: '61763',
  [Icons.ChevronRight24]: '61764',
  [Icons.ChevronLeft]: '61765',
  [Icons.ChevronLeft24]: '61766',
  [Icons.ChevronDown]: '61767',
  [Icons.ChevronDownSmal]: '61768',
  [Icons.ChevronDown24]: '61769',
  [Icons.Chat]: '61770',
  [Icons.Cards]: '61771',
  [Icons.Card]: '61772',
  [Icons.Cancel]: '61773',
  [Icons.BookingIn]: '61774',
  [Icons.Basket]: '61775',
  [Icons.ArrowUp]: '61776',
  [Icons.ArrowLeft]: '61777',
  [Icons.ArrowForward]: '61778',
  [Icons.AddAccount]: '61779',
  [Icons.Account]: '61780',
  [Icons.AccountHeader]: '61781',
  [Icons.i5Columns]: '61782',
  [Icons.i3Columns]: '61783',
  [Icons.i2Columns]: '61784',
  [Icons.i1Columns]: '61785',
};
